import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InvoiceGeneratorMainComponent } from './components/invoice-generator-main/invoice-generator-main.component';
import { EditInvoiceComponent } from './components/edit-invoice/edit-invoice.component';

const routes: Routes = [
    {
        path: 'home',
        component: InvoiceGeneratorMainComponent
    },
    {
        path: 'edit-invoice',
        component: EditInvoiceComponent
    },
    {
        path: 'edit-invoice/:id',
        component: EditInvoiceComponent
    },
    {
        path: 'edit-invoice/:id/:copyType',
        component: EditInvoiceComponent
    },
    {
        path: '',
        redirectTo: "home",
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InvoiceGeneratorRoutingModule {
}
